/** 品牌店付款綁定（Overseas patch 437） */
export const BRAND_STORE_PAYMENT_MENU_IDS = {
  group: 990540,
  bind: 990541,
  view: 990542,
  gate: 990543,
  listing: 990544,
  open: 990545,
  openAccount: 990547
}

export default BRAND_STORE_PAYMENT_MENU_IDS



// WEBPACK FOOTER //
// C:/Users/xiaolan/Desktop/Android/Xrross-SOC-Frontend/E:/xrross/Android/Xrross-SOC-Frontend/src/constants/brandStorePayment.js